// Node Module Imports
import React from 'react'

import { GatsbyImage } from 'gatsby-plugin-image'
import styled from 'styled-components'

// Style Imports
import { above } from '../../style/design-system'

const PyramidPerson = ({
  children, className, gatsbyImage, pyramidColor,
}) => (
  <div className={`${className} d-flex flex-wrap align-items-center pt-9 pt-md-0`}>
    <div className="container">
      <div className="row">
        <div className="col-12 col-md-5 content-wrap">
          <div className="content">
            {children}
          </div>
        </div>
        <div className="col-12 col-md-7 d-flex flex-column justify-content-end">
          <div className="img-wrap text-center mt-6">
            <GatsbyImage image={gatsbyImage.image} alt="" />
          </div>
          <div className="triangle">
            <div className="inner">
              <div className={`bg--${pyramidColor}-chev north`} />
            </div>
            <div className="inner-white" />
          </div>
        </div>
      </div>
    </div>
  </div>
)

export default styled(PyramidPerson)`
  overflow: hidden;
  position: relative;
  text-align: center;

  ${above.md`
    text-align: left;
  `}

  .content-wrap {
    display: flex;
    flex-direction: column;
    justify-content: flex-end;

    ${above.md`
      padding-top: 0;
      justify-content: center;
    `}
  }

  .img-wrap {
    margin: 0 auto;
    max-height: 60vh;
    max-width: 292px;
    position: relative;
    width: 100%;

    ${above.md`
      margin: 0;
      left: 30%;
      max-height: 90vh;
    `}

    ${above.lg`
      margin: 0 auto;
      left: 0;
      max-width: 425px;
    `}
  }

  .triangle {
    height: 110vh;
    overflow: hidden;
    position: absolute;
    top: 25%;
    left: 50%;
    transform: rotate(45deg);
    transform-origin: top left;
    width: 100vw;
    z-index: -1;

    ${above.md`
      left: 68%;
    `}

    ${above.lg`
      left: 50%;
    `}

    .inner {
      height: 150%;
      position: absolute;
      top: -50%;
      left: -50%;
      transform: rotate(-45deg);
      width: 150%;
    }

    .bg--green-chev {
      z-index: -1;
    }

    .inner-white {
      background-color: #fff;
      position: absolute;
      top: 100px;
      right: 0;
      bottom: 0;
      left: 100px;

      ${above.lg`
        top: 150px;
        left: 150px;
      `}
    }
  }
`
